// @ts-ignore
import throttle from 'lodash/throttle';
import {ClickOutside} from "./ClickOutsideClass";

export class Header {
  slimClass: string;
  activeClass: string;
  header: HTMLElement;
  searchTrigger: HTMLElement;
  searchTarget: HTMLElement;
  languageTrigger: HTMLElement;
  languageTarget: HTMLElement;
  subNavigationTriggers: NodeListOf<HTMLElement>;

  constructor() {
    this.slimClass = 'is-slim';
    this.header = document.querySelector('[data-header]');
    if (this.header === null) {
      return;
    }
    this.activeClass = 'is-active';
    this.subNavigationTriggers = this.header.querySelectorAll('[data-header-subnavigation-trigger]');
    this.searchTrigger = this.header.querySelector('[data-header-search-trigger]');
    this.searchTarget = this.header.querySelector('[data-header-search-target]');
    this.languageTrigger = this.header.querySelector('[data-header-language-trigger]');
    this.languageTarget = this.header.querySelector('[data-header-language-target]');
    this.init();
  }

  init() {
    this.resizeHeaderHeight();
    this.addEventListeners();
  }

  addEventListeners() {
    window.addEventListener('scroll', throttle(() => {
      this.resizeHeaderHeight();
    }, 250));

    this.subNavigationTriggers.forEach((trigger: HTMLElement) => {
      const key: string = trigger.dataset.headerSubnavigationTrigger;
      const target: HTMLElement = this.header.querySelector('[data-header-subnavigation-target="' + key + '"]');
      const close: HTMLElement = target.querySelector('[data-header-subnavigation-close]');

      if (target != null) {
        trigger.addEventListener('click', () => {
          target.classList.toggle(this.activeClass);
        });

        close.addEventListener('click', () => {
          target.classList.remove(this.activeClass);
        });

        ClickOutside.addClickOutside([target, trigger], () => {
          target.classList.remove(this.activeClass)
        });
      }
    });

    if (this.searchTrigger != null && this.searchTarget != null) {
      this.searchTrigger.addEventListener('click', () => {
        this.searchTarget.classList.toggle(this.activeClass);
      });

      ClickOutside.addClickOutside([this.searchTarget, this.searchTrigger], () => {
        this.searchTarget.classList.remove(this.activeClass)
      });
    }

    if (this.languageTrigger != null && this.languageTarget != null) {
      this.languageTrigger.addEventListener('click', () => {
        this.languageTarget.classList.toggle(this.activeClass);
      });

      ClickOutside.addClickOutside([this.languageTarget, this.languageTrigger], () => {
        this.languageTarget.classList.remove(this.activeClass)
      });
    }
  }

  resizeHeaderHeight() {
    if (window.scrollY >= 50) {
      this.header.classList.add(this.slimClass);
    } else {
      this.header.classList.remove(this.slimClass);
    }
  }

}
document.addEventListener("DOMContentLoaded", function() {
  new Header();
});
